<div
  class="keypad-button-text"
  [attr.e2e-attr]="E2E_ATTRIBUTES.KEY_PAD_BUTTON_TEXT"
  (click)="onClick()"
>
  <p [attr.e2e-attr]="E2E_ATTRIBUTES.KEY_PAD_BUTTON_VALUE">
    {{ keyPadButton.value }}
  </p>
</div>
